import { render, staticRenderFns } from "./SPLinkTracking.vue?vue&type=template&id=ebb98b0e&scoped=true&"
import script from "./SPLinkTracking.vue?vue&type=script&lang=ts&"
export * from "./SPLinkTracking.vue?vue&type=script&lang=ts&"
import style0 from "./SPLinkTracking.vue?vue&type=style&index=0&id=ebb98b0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb98b0e",
  null
  
)

export default component.exports